exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tanpawrap[data-v-542b9fb2]{white-space:nowrap}", ""]);

// exports
